import { z } from "zod";

/** Progress over the albums of a project that have a checklist, for the grid and the header. */
export const checklistSummarySchema = z.object({
  albumCount: z.number(),
  albumName: z.string().nullable(),
  itemsChecked: z.number(),
  itemsTotal: z.number(),
});

const checklistItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  guidance: z.string(),
  requiredCount: z.number(),
  /** Photos assigned that the caller may see. For an IE, shared photos only. */
  assignedCount: z.number(),
  photos: z.array(z.object({ id: z.string(), fileName: z.string() })),
  checked: z.boolean(),
  /** Who and when are the PM's record: an IE gets null for both. */
  checkedBy: z.string().nullable(),
  checkedAt: z.string().nullable(),
});
export type ChecklistItem = z.infer<typeof checklistItemSchema>;

const checklistAlbumSchema = z.object({
  albumId: z.string(),
  albumName: z.string(),
  items: z.array(checklistItemSchema),
});
export type ChecklistAlbum = z.infer<typeof checklistAlbumSchema>;

export const checklistResponseSchema = z.object({
  data: z.object({ albums: z.array(checklistAlbumSchema) }),
});

export const assignPhotosSchema = z.object({
  photoIds: z.array(z.string().min(1)).min(1).max(500),
  assigned: z.boolean(),
});
export type AssignPhotosRequest = z.infer<typeof assignPhotosSchema>;

export const setCheckSchema = z.object({ checked: z.boolean() });
